'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.webClientMessageWrapper = webClientMessageWrapper;
exports.default = webClientMessage;
function webClientMessageWrapper(state) {
    var getRecords = function getRecords() {
        return state.records;
    };
    var getFields = function getFields() {
        var recordIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getRecords()[recordIndex];
    };
    return {
        getTopic: function getTopic() {
            return state.topic;
        },
        getRecords: getRecords,
        getFields: getFields,
        getRecord: function getRecord(recordIndex) {
            return { fields: getFields(recordIndex) };
        }
    };
}

function webClientMessage(data, topic) {
    var replaceEmptyWithString = function replaceEmptyWithString(item) {
        return item === undefined || item === null ? '' : item;
    };
    var records = data.map(function (record) {
        return record.map(replaceEmptyWithString);
    });
    var state = {
        topic: topic,
        records: records.map(function (record) {
            return { fields: record };
        })
    };
    return Object.assign(state, webClientMessageWrapper({
        topic: topic,
        records: records
    }));
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/webClientMessage.js
// module id = 2660
// module chunks = 1